// ======================================================================
// File Name       : UserUtils
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import moment from 'moment';
import * as UserConstants from '../constants/UserConstants';
import { LO_SUPER_USER, SUPER_USER } from '../constants/index';
  /**
 * Convert node group to node string
 *
 * @param {Object} data
 * @param {Array} groupList
 * return @param {String} nodeStr
 */
export function convertNodeGroupToNodeString(groupSecernId, groupList) {
  let nodeStr = '';
  const node = (child) => {
    const parentId = child ? child.parentGroupSecernId : '';
    groupList.reduce((childrens, group) => {
      if (group.groupSecernId === parentId) {
        nodeStr = `${group.groupName} > ${nodeStr}`;
        node(group);
      }
    }, []);
  };
  if (groupList && groupList.length) {
    for (const group of groupList) {
      if (groupSecernId === group.groupSecernId) {
        nodeStr = group.groupName;
        node(group);
      }
    }
  }
  return nodeStr;
}

export function convertObjectGroupRelationToUserList(groupRelationList) {
  const userList = [];
  for (const groupRelationItem of groupRelationList) {
    let indexOf = null;
    indexOf = userList.indexOf(groupRelationItem.userSecernId);
    if (indexOf === -1) {
      userList.push(groupRelationItem.userSecernId);
    }
  }
  return userList;
}

export function convertObjectToList(dataList, namePrimaryKey, nameMapArray) {
  if (dataList && dataList.length !== 0) {
    const bySecernId = dataList.reduce((newData, obj) => {
      let array = [];
      if (Object.prototype.hasOwnProperty.call(newData, obj[namePrimaryKey])) {
        if (nameMapArray === 'courseStatus') {
          newData[obj[namePrimaryKey]].count += 1;
          if (obj[nameMapArray] == '1') {
            newData[obj[namePrimaryKey]].completed += 1;
          }
        } else {
          array = newData[obj[namePrimaryKey]][nameMapArray];
          if (array && array.length !== 0) {
            const indexOf = array.indexOf(obj[nameMapArray]);
            if (indexOf === -1) {
              array.push(obj[nameMapArray]);
            }
          }
        }
      } else {
        if (nameMapArray === 'courseStatus') {
          newData[obj[namePrimaryKey]] = {
            count: 1,
            completed: obj[nameMapArray] == '1' ? 1 : 0,
          };
        } else {
          array.push(obj[nameMapArray]);
          newData[obj[namePrimaryKey]] = {
            [nameMapArray]: array,
          };
        }
      }
      return newData;
    }, {});
    return bySecernId;
  }
  return [];
}

export function convertUserIdToUserName(userSecernId, userList) {
  let userName = null;
  if (userList && userList.length !== 0) {
    for (const userItem of userList) {
      if (userItem.userSecernId === userSecernId) {
        userName = userItem.userName;
        break;
      }
    }
  }
  return userName;
}

export function convertGroupListIdToGroupName(groupListId, groupList) {
  let groupName = null;
  if (groupList && groupList.length !== 0 && groupListId && groupListId.length > 0) {
    for (const groupId of groupListId) {
      for (const groupItem of groupList) {
        if (groupItem.groupSecernId === groupId) {
          if (!groupName) {
            groupName = groupItem.groupName;
          } else {
            // groupName += ', ' + groupItem.groupName;
            groupName += `, ${groupItem.groupName}`;
          }
          break;
        }
      }
    }
  }
  return groupName;
}

// Step10.0.0 START
export function getCourseStatus(id, getCourseStatusEnd = false) {
  let status = '';
  for (const key in UserConstants.COURSE_COMPLETITION_STATUS_ID) {
    const item = UserConstants.COURSE_COMPLETITION_STATUS_ID[key];
    if (UserConstants.COURSE_COMPLETITION_STATUS_ID[key] == id) {
      if(getCourseStatusEnd) {
        status = UserConstants.COURSE_COMPLETITION_STATUS_END_NAME[key];
      }
      else {
        status = UserConstants.COURSE_COMPLETITION_STATUS_NAME[key];
      }
    }
  }
  return status;
}
// Step10.0.0 END

export function mapUserSecernIdWithGroupName(userSecernId, groupRelationList, groupInfo) {
  const groupRelations = [];
  let groupNames = '';
  groupRelationList.forEach((groupRelation) => {
    if (userSecernId === groupRelation.userSecernId) {
      groupRelations.push({ groupSecernId: groupRelation.groupSecernId });
      const group = groupInfo.bySecernId[groupRelation.groupSecernId];
      if (group) {
        groupNames = groupNames === '' ? group.groupName : (groupNames += `, ${group.groupName}`);
      }
    }
  });
  return groupNames;
}

export function createArrayDurationForChart(
  liveStartFrom,
  liveStartTo,
  liveEnteringLeavingDateList,
) {
  const arrayMoment = [];
  const defaultMoment = moment().startOf('minute');
  if (!liveStartFrom) {
    liveStartFrom = defaultMoment;
  }
  if (!liveStartTo) {
    liveStartTo = defaultMoment.add(1, 'minute');
  }
  arrayMoment.push(liveStartFrom);
  if (isArray(liveEnteringLeavingDateList)) {
    for (let i = 0; i < liveEnteringLeavingDateList.length; i++) {
      let liveEnteringDate = liveEnteringLeavingDateList[i].liveEnteringDate;
      let liveLeavingDate = liveEnteringLeavingDateList[i].liveLeavingDate;
      liveEnteringDate = moment(liveEnteringDate);
      arrayMoment.push(liveEnteringDate);
      liveLeavingDate = moment(liveLeavingDate);
      arrayMoment.push(liveLeavingDate);
    }
  }
  arrayMoment.push(liveStartTo);
  let allTime = 0;
  const arrayDurationValue = [];
  for (let j = 0; j < arrayMoment.length; j++) {
    if (j + 1 < arrayMoment.length) {
      const duration = Math.abs(arrayMoment[j + 1].diff(arrayMoment[j]));
      allTime += duration;
      arrayDurationValue.push(duration);
    }
  }
  const arrayPercentValue = [];
  if (arrayDurationValue.length > 0) {
    for (let o = 0; o < arrayDurationValue.length; o++) {
      const percent = Math.round((arrayDurationValue[o] / allTime) * 100);
      arrayPercentValue.push(percent);
    }
  }
  return arrayPercentValue;
}

export function isArray(object) {
  return Object.prototype.toString.call(object) === '[object Array]';
}

export function isSuperUser(displayUserType) {
  const displayUserTypeParse = parseInt(displayUserType, 10);
  if (isNaN(displayUserTypeParse)) return false;
  return [LO_SUPER_USER, SUPER_USER].indexOf(displayUserType) > -1;
}
